import type {InputProps} from 'src/types/react';

import * as React from 'react';

import classify from 'src/utils/classify';

import css from './number-input.css';

/**
 * Number Input
 *
 * Allows the user more control over the string in the input in a controlled
 * context. Currently only works with integers but could be made to work with
 * floats as well.
 *
 * Passes the value as a number to the `onChange` handler and the original
 * event as the second parameter.
 */
export default class NumberInput extends React.PureComponent<
  InputProps & {
    isFloat?: unknown;
    emptyValue?: number;
    min?: number;
    max?: number;
    onChange: (
      value: number,
      event: React.ChangeEvent<HTMLInputElement>,
    ) => unknown;
    onBlur?: () => unknown;
    value?: number;
    error?: string;
    className?: string;
    disabled?: boolean;
  }
> {
  input: null | HTMLInputElement = null;

  getEmptyValue(): number {
    const {props} = this;

    let emptyValue;
    // @ts-expect-error - TS2339 - Property 'emptyValue' does not exist on type 'never'. | TS2339 - Property 'emptyValue' does not exist on type 'never'.
    if (props.emptyValue != null && Number.isFinite(props.emptyValue)) {
      // @ts-expect-error - TS2339 - Property 'emptyValue' does not exist on type 'never'.
      emptyValue = props.emptyValue;
      // @ts-expect-error - TS2339 - Property 'min' does not exist on type 'never'. | TS2339 - Property 'min' does not exist on type 'never'.
    } else if (props.min != null && Number.isFinite(props.min)) {
      // @ts-expect-error - TS2339 - Property 'min' does not exist on type 'never'.
      emptyValue = props.min;
    } else {
      emptyValue = 0;
    }

    return emptyValue;
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<never, {}, any>'.
  render(): React.ReactElement<React.ComponentProps<'input'>> {
    // @ts-expect-error - TS2700 - Rest types may only be created from object types.
    const {onChange, onBlur, emptyValue, value, error, className, ...props} =
      this.props;
    return (
      <input
        type="number"
        {...props}
        ref={this.handleRef}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        defaultValue={value}
        className={classify(className, {
          [css.errorBox]: error,
        })}
      />
    );
  }

  _handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const {
      target: {value},
    } = event;

    let mappedValue;
    if (value === '') {
      mappedValue = this.getEmptyValue();
    } else {
      // @ts-expect-error - TS2339 - Property 'isFloat' does not exist on type 'never'.
      mappedValue = this.props.isFloat ? parseFloat(value) : parseInt(value);
    }

    // @ts-expect-error - TS2339 - Property 'onChange' does not exist on type 'never'.
    this.props.onChange(mappedValue, event);
  }
  handleChange: any = this._handleChange.bind(this);

  _handleBlur() {
    const {input, props} = this;

    if (input) {
      if (input.value === '') {
        input.value = this.getEmptyValue().toString();
        // @ts-expect-error - TS2339 - Property 'isFloat' does not exist on type 'never'.
      } else if (!this.props.isFloat) {
        input.value = parseInt(input.value).toString();
      }
    }

    // @ts-expect-error - TS2339 - Property 'onBlur' does not exist on type 'never'.
    if (props.onBlur) {
      // @ts-expect-error - TS2339 - Property 'onBlur' does not exist on type 'never'.
      props.onBlur();
    }
  }
  handleBlur: any = this._handleBlur.bind(this);

  _handleRef(el: HTMLInputElement) {
    this.input = el;
  }
  handleRef: any = this._handleRef.bind(this);
}

/**
 * This number input is uses type="text" to support browsers like IE and Safari.
 * It's mainly used in candidate-facing Surveys.
 */
export const NumberInputNew = (props: {
  isFloat?: boolean;
  onChange: (
    value: string,
    event?: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  value: string;
  className?: string;
  placeholder?: string;
  error?: string;
}): React.ReactElement<React.ComponentProps<'input'>> => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let trimmedValue = event.target.value;

    if (trimmedValue !== '') {
      if (props.isFloat) {
        trimmedValue = String(trimmedValue).replace(/[^\d.]/g, '');

        if (
          trimmedValue[trimmedValue.length - 1] === '.' &&
          trimmedValue.slice(0, trimmedValue.length - 1).includes('.')
        ) {
          //remove the last decimal separator if one already exists
          trimmedValue = trimmedValue.slice(0, trimmedValue.length - 1);
        }
      } else {
        trimmedValue = String(trimmedValue).replace(/[^\d]/g, '');
      }
    }

    props.onChange(trimmedValue, event);
  };

  return (
    <input
      type="text"
      {...props}
      onChange={handleChange}
      className={classify(props.className, {
        [css.errorBox]: props.error,
      })}
    />
  );
};
